export default __webpack_public_path__ + "static/media/negotiations-icon.04c372ba.svg";